import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NewEmbedUi, updateVisualMedia } from './visual_media_shared';

export default function VisualMediaEmbedsCustomer({
  parentName,
  selectedVisualMediaIds,
  visualMediaEmbeds,
  onBulkCheckboxClick,
  onChange
}) {
  const handleVisualMediaChange = visualMediaForCustomers => onChange(visualMediaForCustomers);

  const updateVisualMediaEmbed = (visualMedia, column, newValue) => {
    const newVisualMediaEmbeds = updateVisualMedia(visualMediaEmbeds, visualMedia.id, column, newValue);
    handleVisualMediaChange(newVisualMediaEmbeds);
  };

  const isVisualMediaEmpty = () => visualMediaEmbeds.every(item => item.destroy);

  return (
    <Fragment>
      <div className="photo-grid">
        <NewEmbedUi
          isCustomer
          parentName={parentName}
          selectedVisualMediaIds={selectedVisualMediaIds}
          updateVisualMediaEmbed={updateVisualMediaEmbed}
          visualMediaEmbeds={visualMediaEmbeds}
          onBulkCheckboxClick={onBulkCheckboxClick}
        />
      </div>
      {isVisualMediaEmpty() && (
        <div className="visual-media-block text-muted">
          No visual media content
        </div>
      )}
    </Fragment>
  );
}

VisualMediaEmbedsCustomer.propTypes = {
  parentName: PropTypes.string.isRequired,
  selectedVisualMediaIds: PropTypes.array.isRequired,
  visualMediaEmbeds: PropTypes.arrayOf(PropTypes.shape({
    embedUrl: PropTypes.string,
    description: PropTypes.string,
    fetchThumbnailUrl: PropTypes.string,
    mediaType: PropTypes.string,
    id: PropTypes.number,
    sortOrder: PropTypes.number,
    thumbnailUrl: PropTypes.string,
  })),
  onBulkCheckboxClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};
